import { render } from "./InternalTransferFullFailure.vue?vue&type=template&id=63934d9b&scoped=true"
import script from "./InternalTransferFullFailure.vue?vue&type=script&lang=js"
export * from "./InternalTransferFullFailure.vue?vue&type=script&lang=js"

import "./InternalTransferFullFailure.vue?vue&type=style&index=0&id=63934d9b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63934d9b"]])

export default __exports__